
import BgShape from "../images/hero/bookbg1.jpg";
function Banner() {


  const bgImageStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  };


  return (
    <>
      <section
        className="banner-section"
        style={{
         // backgroundColor: "#00b712",
          //backgroundImage: "linear-gradient(275deg, #00690a 0%, #3a9e0e 79%)"
          position: 'relative'
        }}
      >
  <img src={BgShape} alt="Background Shape" style={bgImageStyle} />

        <div className="container">
          <div className="row">
            <div className="col-12" style={{ height: "220px" }}>
              <div className="banner-content">
                <div className="banner-content__text" style={{
                backgroundColor: 'rgba(0, 0, 0, 0.29)' , width:'100%'
              }}  >
                  <h2>Best Car Rental In Jamaica</h2>
                 
                </div>
              </div>
            </div>

            <div className="col-12" style={{ height: "270px" }}>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.2256817876283!2d-77.1976487!3d18.4337628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xabb0bf07ae8e4e8b%3A0xc011c7fe0fa805fa!2sSleek%20Image%20Rentals%20and%20Transportation%20services!5e0!3m2!1sen!2sjm!4v1692013563264!5m2!1sen!2sjm"
                width="100%"
                height="100%"
                style={{ border: "0" }}
                allowFullScreen=""
                loading="eager"
              ></iframe>       
            </div>
            
          </div>
        </div>
      </section>
    </>
  );
}

export default Banner;
